import React, { useEffect } from 'react';
import { rta } from 'store/application';
import { Button } from '@tencent/spaui';
import Tabs from 'components/tabs';
import { showDialog } from 'components/dialog';
import agent from 'images/agent.png';
import customer from 'images/customer.png';
import './index.scss';

const ApplyDialog = (
  <>
    <div className="item">
      <img src={agent} alt="" />
      <div className="text-bold">我是代理商</div>
      <div className="text-desc">请填写问卷信息，若运营审核通过，将与您联系。</div>
      <a href="https://wj.qq.com/s2/12854576/75d7/" className="rect-button" target="_blank" rel="noreferrer">
        填写问卷
      </a>
    </div>
    <div className="item">
      <img src={customer} alt="" />
      <div className="text-bold">我是直客</div>
      <div className="text-desc">您可联系对接的客户运营或销售。或直接联系RTA产品团队：</div>
      <a href="mailto:tingzheng@tencent.com" target="_blank" rel="noreferrer">
        tingzheng@tencent.com
      </a>
    </div>
  </>
);

export const showApplyDialog = () => {
  showDialog({ title: '自建 RTA 工具使用申请', content: ApplyDialog, className: 'apply-dialog' });
};

const Rta: React.FC = () => {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <main className="rta-page">
      <div className="header">
        <img src={rta.app_icon} alt="" />
        <div className="text-bold">{rta.app_name}</div>
        <Button className="a-button large" displayType="primary" onClick={showApplyDialog}>
          立即申请
        </Button>
      </div>
      <Tabs tabs={['RTA 介绍', '对接操作和文档']} trigger="click" fixedIndicator={false}>
        <div>
          <p>
            RTA(Realtime
            API)是一种结合直投&标准程序化方式探索的基础功能，在目前腾讯广告投放管理平台（ADQ投放端）直投投放模式的基础上，下发请求数据给客户，客户返回决策信息，平台结合客户信息进行优选，最终提升广告投放效果。
          </p>
          <div className="text-bold">1. RTA能满足客户诉求</div>
          <p>
            个性化用户筛选：客户基于自有模型判定每次请求的用户价值，媒体根据客户返回“是否参与本次竞价”的结果，确定广告后续竞争与否的选择。
          </p>
          <p>流量实时优选：媒体实时询问客户是否参竞，并结合客户的实时回复进行最终优选。</p>
          <div className="text-bold">2. 解析RTA与标准直投、程序化的区别</div>
          <p>
            腾讯RTA则是结合标准直投和程序化两种投放模式各自的优点，在现有直投模式上推出的创新模式。且RTA功能的开通不会影响线上直投现有所有功能。
          </p>
          <p>
            RTA：RTA在现有直投功能不变的基础上，实时下发请求给广告主，目前包含腾讯优量汇、腾讯新闻、腾讯视频、微信及其他腾讯APP（应用宝除外）的请求，广告主利用一方数据返回决策信息，媒体结合广告主决策信息进行优选。
          </p>
          <p>
            标准直投：广告主通过MKT-API或者直接在腾讯广告投放管理平台（ADQ投放端）创建广告进行广告投放，利用媒体侧数据和投放模型进行优选。
          </p>
          <p>
            程序化：即“ADX”，媒体提供流量，广告主利用自有数据及投放模型完成投放。ADX广告无法利用媒体侧投放模型，广告主利用一方数据及自有投放模型完成投放。
          </p>
          <div className="text-bold">3. RTA可以解决哪些问题</div>
          <p>精准购买用户，将“用户划分定义”交给客户，满足客户筛选高价值用户的诉求。</p>
          <p>提升联盟流量筛选效率，将流量筛选时机从“投放后”提前到“竞价中”，过滤低转化流量。</p>
          <p>
            在广告竞价中，客户可引入自身算法能力，实现“对不同价值的用户实时出价”能力，进一步提高买量效果，且RTA开发成本低。
          </p>
          <p>基于广告主一方积累的商品行为数据，通过RTA实现一方实时商品推荐，提升商品广告效果。</p>
        </div>
        <div>
          <div className="text-bold">1. 对接模式和相关技术文档</div>
          <p>目前腾讯提供两种对接方式：</p>
          <p className="intent-1">1.1 实时下发模式</p>
          <p className="intent-2">1.1.1 对接门槛</p>
          <p className="intent-2">客户技术门槛：需有能力完成RTA接口开发。</p>
          <p className="intent-2">
            能承受RTA高峰值请求量。RTA接口QPS峰值：缓存1小时的情况下，优量汇15万、腾讯新闻&视频流量10万、腾讯内部其他APP15万。
          </p>
          <p className="intent-2">
            在要求时间内完成请求响应，请求响应时间为60ms。机器分布情况：优量汇主要分布在天津、上海，少量在深圳；腾讯新闻&视频及腾讯APP主要分布在深圳。
          </p>
          <p className="intent-2">客户预算门槛：客户当前在直投日均消耗不低于5W，接入RTA后日均消耗不低于10W；</p>
          <p className="intent-2">1.1.2 技术文档：</p>
          <p className="intent-2">
            <a href="https://docs.qq.com/doc/DVUN6U2NJektwa2ZF" target="_blank" rel="noreferrer">
              https://docs.qq.com/doc/DVUN6U2NJektwa2ZF
            </a>
          </p>
          <div className="intent-1">1.2 非实时下发模式：</div>
          <p className="intent-2">1.2.1 对接门槛</p>
          <p className="intent-2">客户技术门槛：需有能力完成RTA接口开发。</p>
          <p className="intent-2">客户预算门槛：客户当前在直投日均消耗不低于2W，接入RTA后日均消耗不低于2W；</p>
          <p className="intent-2">1.2.2 技术文档：</p>
          <p className="intent-2">
            <a href="https://docs.qq.com/doc/DSWxYUXdGSWtJSFdM" target="_blank" rel="noreferrer">
              https://docs.qq.com/doc/DSWxYUXdGSWtJSFdM
            </a>
          </p>
          <div className="text-bold">2. 客户侧对接流程</div>
          <p>
            接口开发：参照《腾讯RTA接口文档》完成接口协议对接，用于接收腾讯流量的广告请求；接口开发完成后联系腾讯运营进行接口调通和放量。（协议文档请联系接口人提供）
          </p>
          <p>
            RTA功能准入：新建或者申请将已有账户/广告用作RTA投放，确定接口信息和账户后联系客户运营联系人发RTA接入申请邮件；
          </p>
          <p>正常使用RTA策略：接收腾讯侧的广告请求，根据下发的请求信息判断是否参竞广告。</p>
        </div>
      </Tabs>
    </main>
  );
};

export default Rta;
